import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { theme } from "src/theme/theme";
import { trainwellColor } from "src/theme/themePrimitives";

const StyledIconButton = styled(IconButton)({
  margin: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: trainwellColor.neutral2,
  "&:hover": {
    backgroundColor: trainwellColor.neutral3,
  },
  "&:active": {
    backgroundColor: trainwellColor.neutral5,
  },
});

export default StyledIconButton;
